import { ReportData } from "src/hooks/usePowerBiReport";
import { omniAtom } from "src/utils/atoms";

const prefix = "merchandise";

export const powerBiReportsAtom = omniAtom({
  prefix,
  key: "powerBiReports",
  value: null as ReportData | null,
});
